import React, { useContext } from "react";
import { Link } from "react-router-dom";
import "./Toolbar.css";
import "../SideDrawer/DrawerToggleButton";
import { store } from "../../store.js";
import UserIcon from "../Commands/UserIcon/UserIcon";
import HelpIcon from "../Commands/HelpIcon/HelpIcon";
import SettingsBarIcon from "../Commands/SettingsBarIcon/SettingsBarIcon";
import HomeIcon from "../Commands/HomeIcon/HomeIcon"; 
import AlertBarIcon from "../Commands/AlertBarIcon/AlertBarIcon";
import PendingTaskIcon from "../Commands/PendingTaskIcon/PendingTaskIcon";
import RequestIcon from "../Commands/RequestIcon/RequestIcon"; 
import InProgressIcon from "../Commands/InProgressIcon/InProgressIcon";

export default function Toolbar (props) {
  const globalState = useContext(store);
 
 /*
  <div className="toolbar_toggle_button">
          <DrawerToggleButton click={props.drawerClickHandler} />
        </div>
 */

  return (
    <header className="toolbar" style = {{height: props.height}}>
      <nav className="toolbar_navigation">
        
        <div className="toolbar_logo">
          <HomeIcon />
        </div>
        <div className="spacer" />
        {!globalState.state.authenticate ?
          <div className="toolbar_navigation-items">
            <Link to="/demo">Demo</Link>
            <Link to="/register">Register</Link>
            <Link to="/signin">Sign in</Link>
            <Link to="/aboutus">About us</Link>
            <Link to="/contactus">Contact us</Link>
          </div>
          :
          <div className="toolbar_navigation-items">
            <Link to="/request">
              Request
            </Link>
            <Link to="/kanban">
              Task Board
            </Link>
            <Link to="/Gantt">
              Consultation
            </Link>
          
            <Link to="/aboutus">
              <HelpIcon />
            </Link>
            <Link to="/contactus">
                <div style = {{display: "flex"}}>
                  <div style = {{marginLeft: "5px", marginRight: "5px"}}>
                    <span>{globalState.state.company && globalState.state.company.fullName}</span>
                  </div>
                  <UserIcon />
                </div>
            </Link>
          </div>
        }
      </nav>
    </header>
  );
};


